import React, { useState } from 'react';
import { faqs as initialFaqs, faqCategories, OFFICIAL_SUPPORT_URL } from '../data/faqs';
import './FAQPage.css';

export default function FAQPage({ faqs = initialFaqs }) {
  const [activeCategory, setActiveCategory] = useState('all');
  const [searchQuery, setSearchQuery] = useState('');
  const [openId, setOpenId] = useState(null);

  const filteredFaqs = faqs.filter(faq => {
    const matchesCat = activeCategory === 'all' || faq.category === activeCategory;
    const matchesSearch = faq.question.toLowerCase().includes(searchQuery.toLowerCase()) ||
                          faq.answer.toLowerCase().includes(searchQuery.toLowerCase());
    return matchesCat && matchesSearch;
  });

  const toggleFAQ = (id) => {
    setOpenId(openId === id ? null : id);
  };

  return (
    <div className="faq-page-wrapper">
      <div className="container">

        {/* Page Header */}
        <div className="faq-page-header text-center">
          <span className="badge-volt pulse-glow-volt">HELP CENTER &amp; KNOWLEDGE BASE</span>
          <h1 className="faq-page-title">FREQUENTLY ASKED QUESTIONS</h1>
          <p className="faq-page-subtitle">
            Everything you need to know about Playermaker 2.0 sensors, Canadian shipping, subscription memberships, and app syncing.
          </p>
        </div>

        {/* Official Playermaker Support Banner */}
        <div className="official-support-card card-tech">
          <div className="support-card-content">
            <div className="support-icon-badge">⚡</div>
            <div>
              <span className="badge-volt">OFFICIAL PLAYERMAKER HELP PORTAL</span>
              <h2 className="support-card-title">Need technical troubleshooting or app account assistance?</h2>
              <p className="support-card-desc">
                Visit the official Playermaker Support Center for detailed device firmware manuals, sensor pairing guides, and global ticket support.
              </p>
            </div>
          </div>
          <div className="support-card-actions">
            <a 
              href={OFFICIAL_SUPPORT_URL} 
              target="_blank" 
              rel="noopener noreferrer" 
              className="btn btn-volt support-link-btn"
            >
              Visit Playermaker Support Portal
            </a>
          </div>
        </div>

        {/* Controls: Search & Category Filter */}
        <div className="faq-controls card-tech">
          <div className="faq-search-wrapper">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="11" cy="11" r="8"/>
              <line x1="21" y1="21" x2="16.65" y2="16.65"/>
            </svg>
            <input 
              type="text" 
              placeholder="Search all FAQs by keyword (e.g. battery, waterproof, shipping, size)..." 
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="faq-search-input"
            />
            {searchQuery && (
              <button className="search-clear-btn" onClick={() => setSearchQuery('')}>✕</button>
            )}
          </div>

          <div className="faq-category-pills">
            {faqCategories.map(cat => (
              <button
                key={cat.id}
                className={`faq-pill ${activeCategory === cat.id ? 'active' : ''}`}
                onClick={() => setActiveCategory(cat.id)}
              >
                {cat.name}
              </button>
            ))}
          </div>
        </div>

        {/* FAQ List */}
        <div className="faq-page-results-count">
          <h3>
            SHOWING QUESTIONS 
            <span className="results-badge">({filteredFaqs.length})</span>
          </h3>
        </div>

        {filteredFaqs.length === 0 ? (
          <div className="no-faqs-card card-tech text-center">
            <h3>No matching questions found</h3>
            <p>We couldn't find an answer for "{searchQuery}". You can check the official support portal or contact us directly.</p>
            <div className="flex-center" style={{ gap: '1.6rem', marginTop: '1.6rem' }}>
              <button className="btn btn-outline" onClick={() => { setSearchQuery(''); setActiveCategory('all'); }}>
                Clear Filters
              </button>
              <a href={OFFICIAL_SUPPORT_URL} target="_blank" rel="noopener noreferrer" className="btn btn-volt">
                Playermaker Support
              </a>
            </div>
          </div>
        ) : (
          <div className="faq-page-list">
            {filteredFaqs.map(faq => (
              <div 
                key={faq.id} 
                className={`faq-item card-tech ${openId === faq.id ? 'open' : ''}`}
                onClick={() => toggleFAQ(faq.id)}
              >
                <div className="faq-question-row">
                  <h3 className="faq-question">{faq.question}</h3>
                  <span className="faq-toggle-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <line x1="12" y1="5" x2="12" y2="19" className="vertical-line" />
                      <line x1="5" y1="12" x2="19" y2="12" />
                    </svg>
                  </span>
                </div>
                
                <div className="faq-answer-container">
                  <div className="faq-answer" dangerouslySetInnerHTML={{ __html: faq.answer }}></div>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* Contact Canadian Support Box */}
        <div className="canadian-support-footer card-tech">
          <div className="footer-support-text">
            <h3>STILL HAVE QUESTIONS ABOUT YOUR CANADIAN ORDER?</h3>
            <p>Our Canadian team is here to help with academy club discount codes, expedited shipping status, or 1-year local warranty exchanges.</p>
          </div>
          <div className="footer-support-buttons">
            <a href="mailto:support@ilovethisgame.ca" className="btn btn-volt">
              Email Canadian Support
            </a>
            <a href={OFFICIAL_SUPPORT_URL} target="_blank" rel="noopener noreferrer" className="btn btn-outline">
              Playermaker Support Center
            </a>
          </div>
        </div>

      </div>
    </div>
  );
}
